export default "__VITE_ASSET__728de160__"